import { Button, Close } from '@bphxd/ds-core-react';
import { FC, useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import classes from './JobFiltersModal.module.scss';
import { EMPTY_JOB_FILTERS } from '../../../lib/constants';
import Select from 'react-select';
import { ReactSelectOverrides } from '@bphxd/ds-core-react';
import { optionsFromEnum, stringToOption } from '../../../lib/util/format';
import {
  ECOW_PERMIT_STATUS_MAPPING,
  GOC_STATUS_ENUM,
  INSULATION_STATUS_ENUM,
  JOB_FIELD_WALK_STATUS_ENUM,
  JOB_SCHEDULE_STATUS_ENUM,
  LEAK_TEST_PACK_STATUS_ENUM,
  LIFTPLAN_STATUS_ENUM,
  PROCEDURE_STATUS_ENUM,
  PURCHASE_ORDER_STATUS_ENUM,
  SCAFFOLD_STATUS_ENUM,
  WORKPACK_STATUS_ENUM,
} from '../../../lib/constants/dbConstants';
import clsx from 'clsx';
import { Trash24 } from '@bphxd/ds-core-react/lib/icons';
import { TAspectsTableFilters } from '../AspectsTable/AspectsTable';
import {
  getAugmentedOptionsFromMapping as getOptions,
  getPermitOptions,
  getIsolationOptions,
  getMocOptions,
} from './JobFiltersModal.util';

export type TJobFilters = TAspectsTableFilters<
  | 'workpackStatus'
  | 'scaffoldStatus'
  | 'gocStatus'
  | 'scheduleStatus'
  | 'insulationStatus'
  | 'procedureStatus'
  | 'leakTestPackStatus'
  | 'liftPlanStatus'
  | 'fieldWalkStatus'
  | 'purchaseOrderStatus'
  | 'assignedPlanner'
  | 'jobId'
  | 'permitStatus'
  | 'gocSh1'
  | 'isolationStatus'
  | 'mocStatus'
>;

const TJobFiltersModal: FC<{
  defaultValues: TJobFilters;
  onSubmit: (filters: TJobFilters) => unknown;
  onClose: () => void;
}> = ({ defaultValues, onSubmit, onClose }) => {
  const [filters, setFilters] = useState<TJobFilters>(defaultValues);

  const setFilterByKey = (key: keyof TJobFilters, values: string[]) => {
    setFilters((filters) => ({ ...filters, [key]: values }));
  };
  const handleSubmit = () => {
    onSubmit(filters);
    onClose();
  };

  const handleDelete = () => {
    onSubmit(EMPTY_JOB_FILTERS);
    onClose();
  };

  return (
    <Modal isOpen toggle={onClose} className="modal-dialog-centered">
      <ModalHeader className="border-0 px-6" close={<Close onClick={onClose} />}>
        Filter Jobs
      </ModalHeader>
      <ModalBody className={clsx('p-6 pt-0', classes.root)}>
        <div className={classes.filters}>
          <Form className="row g-5">
            {/* <div className="col-md-6">MO Status</div> */}
            <div className="col-md-6">
              <FormGroup>
                <Label>Lift Plan Status</Label>
                <Select
                  defaultValue={filters.liftPlanStatus.map(stringToOption)}
                  isMulti
                  options={getOptions(LIFTPLAN_STATUS_ENUM)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'liftPlanStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Workpack Status</Label>
                <Select
                  defaultValue={filters.workpackStatus.map(stringToOption)}
                  isMulti
                  options={getOptions(WORKPACK_STATUS_ENUM)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'workpackStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Leak Test Pack Status</Label>
                <Select
                  defaultValue={filters.leakTestPackStatus.map(stringToOption)}
                  isMulti
                  options={getOptions(LEAK_TEST_PACK_STATUS_ENUM)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'leakTestPackStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Scaffold Status</Label>
                <Select
                  defaultValue={filters.scaffoldStatus.map(stringToOption)}
                  isMulti
                  options={getOptions(SCAFFOLD_STATUS_ENUM)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'scaffoldStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>PO Status</Label>
                <Select
                  defaultValue={filters.purchaseOrderStatus.map(stringToOption)}
                  isMulti
                  options={getOptions(PURCHASE_ORDER_STATUS_ENUM)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'purchaseOrderStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            {/* <div className="col-md-6">PO Status</div> */}
            <div className="col-md-6">
              <FormGroup>
                <Label>Insulation Status</Label>
                <Select
                  defaultValue={filters.insulationStatus.map(stringToOption)}
                  isMulti
                  options={getOptions(INSULATION_STATUS_ENUM)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'insulationStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Isolation Status</Label>
                <Select
                  defaultValue={filters.isolationStatus.map(stringToOption)}
                  isMulti
                  options={getIsolationOptions().map(stringToOption)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'isolationStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Permit Status</Label>
                <Select
                  defaultValue={filters.permitStatus.map(stringToOption)}
                  isMulti
                  options={getPermitOptions().map(stringToOption)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'permitStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            {/* <div className="col-md-6">Isolation Status</div> */}
            <div className="col-md-6">
              <FormGroup>
                <Label>Field Walk Status</Label>
                <Select
                  defaultValue={filters.fieldWalkStatus.map(stringToOption)}
                  isMulti
                  options={optionsFromEnum(JOB_FIELD_WALK_STATUS_ENUM)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'fieldWalkStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>GoC Status</Label>
                <Select
                  defaultValue={filters.gocStatus.map(stringToOption)}
                  isMulti
                  options={optionsFromEnum(GOC_STATUS_ENUM)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'gocStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Procedure Status</Label>
                <Select
                  defaultValue={filters.procedureStatus.map(stringToOption)}
                  isMulti
                  options={getOptions(PROCEDURE_STATUS_ENUM)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'procedureStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Schedule Status</Label>
                <Select
                  defaultValue={filters.scheduleStatus.map(stringToOption)}
                  isMulti
                  options={optionsFromEnum(JOB_SCHEDULE_STATUS_ENUM)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'scheduleStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Job ID</Label>
                <Input
                  type="text"
                  title="Use comma to separate multiple values like '101,145'."
                  name="jobId"
                  id="job-id"
                  defaultValue={filters.jobId}
                  onChange={(e) => {
                    const jobIdArrary: string[] = e.target.value.split(',');
                    setFilterByKey('jobId', jobIdArrary);
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>SPA</Label>
                <Input
                  type="text"
                  title="Use comma to separate multiple values like 'Jim,Stuart'. Values need to be exact."
                  name="assignedPlanner"
                  id="assigned-planner"
                  defaultValue={filters.assignedPlanner}
                  onChange={(e) => {
                    const assignedPlannerArrary: string[] = e.target.value.split(',');
                    setFilterByKey('assignedPlanner', assignedPlannerArrary);
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>SH1</Label>
                <Input
                  type="text"
                  title="Use comma to separate multiple values like 'A123,B456'. Values need to be exact."
                  name="gocSh1"
                  id="goc-sh1"
                  defaultValue={filters.gocSh1}
                  onChange={(e) => {
                    const gocSh1Arrary: string[] = e.target.value.split(',');
                    setFilterByKey('gocSh1', gocSh1Arrary);
                  }}
                />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>MOC Status</Label>
                <Select
                  defaultValue={filters.mocStatus.map(stringToOption)}
                  isMulti
                  options={getMocOptions().map(stringToOption)}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  components={ReactSelectOverrides.default}
                  classNamePrefix="react-select"
                  onChange={(newSelection) => {
                    setFilterByKey(
                      'mocStatus',
                      newSelection.map((o) => o.value)
                    );
                  }}
                />
              </FormGroup>
            </div>
            {/* <div className="col-md-6">Assigned Planner</div> */}
            {/* Footer */}
            <div className={clsx('col-md-12', classes.footer)}>
              <Button
                size="lg"
                className=""
                theme="darker"
                level="tertiary"
                onClick={handleDelete}
                Icon={Trash24}
              >
                Remove Filters
              </Button>
              <Button
                disabled={filters === defaultValues}
                size="md"
                className=""
                theme="darker"
                level="primary"
                onClick={handleSubmit}
              >
                Apply Filters
              </Button>
            </div>
          </Form>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TJobFiltersModal;
